// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddMultipleAudios_container__QQcUG {
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem;
    background-color: #000;
    color: #fff;
    min-height: 100vh;
  }
  
  .AddMultipleAudios_title__v14rz {
    font-size: 2rem;
    color: #ff3333;
    margin-bottom: 2rem;
    text-align: center;
  }
  
  .AddMultipleAudios_form__9rC0N {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
  
  .AddMultipleAudios_formGroup__NP1d3 {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .AddMultipleAudios_formGroup__NP1d3 label {
    font-weight: 600;
    color: #ff3333;
  }
  
  .AddMultipleAudios_input__lt78c, .AddMultipleAudios_select__\\+c2Mi, .AddMultipleAudios_textarea__zzCwU {
    padding: 0.75rem 0px;
    border-radius: 4px;
    border: 1px solid #333;
    background-color: #111;
    color: #fff;
    font-size: 1rem;
    width: 100%;
  }
  
  .AddMultipleAudios_textarea__zzCwU {
    min-height: 100px;
    resize: vertical;
  }
  
  .AddMultipleAudios_input__lt78c:focus, .AddMultipleAudios_select__\\+c2Mi:focus, .AddMultipleAudios_textarea__zzCwU:focus {
    border-color: #ff3333;
    outline: none;
  }
  
  .AddMultipleAudios_checkboxLabel__2AQuy {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
  }
  
  .AddMultipleAudios_checkbox__RTH\\+\\+ {
    width: 18px;
    height: 18px;
    accent-color: #ff3333;
  }
  
  .AddMultipleAudios_fileInput__SamwF {
    padding: 0.75rem;
    border-radius: 4px;
    border: 1px solid #333;
    background-color: #111;
    color: #fff;
    width: 100%;
    cursor: pointer;
  }
  
  .AddMultipleAudios_fileInput__SamwF::-webkit-file-upload-button {
    background-color: #ff3333;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    margin-right: 1rem;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .AddMultipleAudios_imageUploadContainer__QP3hJ {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  @media (min-width: 768px) {
    .AddMultipleAudios_imageUploadContainer__QP3hJ {
      flex-direction: row;
      gap: 2rem;
    }
  }
  
  .AddMultipleAudios_imageUpload__uOusD {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .AddMultipleAudios_imagePreview__PzzOM, .AddMultipleAudios_filesPreview__qvsX3 {
    margin-top: 0.5rem;
    padding: 0.5rem;
    background-color: #222;
    border-radius: 4px;
    font-size: 0.9rem;
  }
  
  .AddMultipleAudios_metadataSection__0CaHQ {
    margin-top: 1rem;
    border-top: 1px solid #333;
    padding-top: 1.5rem;
  }
  
  .AddMultipleAudios_metadataSection__0CaHQ h3 {
    font-size: 1.5rem;
    color: #ff3333;
    margin-bottom: 1rem;
  }
  
  .AddMultipleAudios_metadataItem__u3DvI {
    background-color: #111;
    padding: 1.5rem;
    border-radius: 8px;
    margin-bottom: 1.5rem;
    border-left: 4px solid #ff3333;
  }
  
  .AddMultipleAudios_metadataItem__u3DvI h4 {
    margin-top: 0;
    margin-bottom: 1rem;
    font-size: 1.2rem;
    color: #ddd;
  }
  
  .AddMultipleAudios_formAction__Uo2bx {
    margin-top: 2rem;
    display: flex;
    justify-content: center;
  }
  
  .AddMultipleAudios_submitButton__Smhxb {
    background-color: #ff3333;
    color: white;
    border: none;
    padding: 0.75rem 2rem;
    font-size: 1.1rem;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
    min-width: 200px;
  }
  
  .AddMultipleAudios_submitButton__Smhxb:hover {
    background-color: #cc0000;
  }
  
  .AddMultipleAudios_submitButton__Smhxb:disabled {
    background-color: #777;
    cursor: not-allowed;
  }
  
  .AddMultipleAudios_message__2DHj2 {
    padding: 1rem;
    border-radius: 4px;
    margin-bottom: 2rem;
    font-weight: 500;
  }
  
  .AddMultipleAudios_success__p7reB {
    background-color: rgba(0, 128, 0, 0.2);
    color: #4caf50;
    border: 1px solid #4caf50;
  }
  
  .AddMultipleAudios_error__HIZvf {
    background-color: rgba(255, 0, 0, 0.2);
    color: #ff3333;
    border: 1px solid #ff3333;
  }
  .AddMultipleAudios_imagePreview__PzzOM {
    position: relative;
    display: inline-block;
    margin-top: 10px;
  }
  
  .AddMultipleAudios_previewImg__Bu4-V {
    max-width: 100px;
    max-height: 100px;
    border-radius: 6px;
    object-fit: cover;
  }
  
  .AddMultipleAudios_removeBtn__DLz2e {
    position: absolute;
    top: -8px;
    right: -8px;
    background: red;
    color: white;
    border: none;
    border-radius: 50%;
    font-size: 16px;
    width: 24px;
    height: 24px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .AddMultipleAudios_removeAudioBtn__M-ZCW {
    background: transparent;
    border: none;
    color: #ff4d4f;
    font-size: 30px;
    font-weight: bold;
    cursor: pointer;
    margin-left: auto;
  }
  
  .AddMultipleAudios_metadataHeader__XTXqC {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  /* Responsive adjustments */
  @media (max-width: 768px) {
    .AddMultipleAudios_container__QQcUG {
      padding: 1rem;
    }
    
    .AddMultipleAudios_title__v14rz {
      font-size: 1.5rem;
    }
    
    .AddMultipleAudios_metadataItem__u3DvI {
      padding: 1rem;
    }
    
    .AddMultipleAudios_submitButton__Smhxb {
      width: 100%;
    }
  }`, "",{"version":3,"sources":["webpack://./src/admin/pages/multiple-content/AddMultipleAudios.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE;MACE,mBAAmB;MACnB,SAAS;IACX;EACF;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;IACjC,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,sCAAsC;IACtC,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,sCAAsC;IACtC,cAAc;IACd,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA,2BAA2B;EAC3B;IACE;MACE,aAAa;IACf;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,WAAW;IACb;EACF","sourcesContent":[".container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 2rem;\n    background-color: #000;\n    color: #fff;\n    min-height: 100vh;\n  }\n  \n  .title {\n    font-size: 2rem;\n    color: #ff3333;\n    margin-bottom: 2rem;\n    text-align: center;\n  }\n  \n  .form {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n  }\n  \n  .formGroup {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  \n  .formGroup label {\n    font-weight: 600;\n    color: #ff3333;\n  }\n  \n  .input, .select, .textarea {\n    padding: 0.75rem 0px;\n    border-radius: 4px;\n    border: 1px solid #333;\n    background-color: #111;\n    color: #fff;\n    font-size: 1rem;\n    width: 100%;\n  }\n  \n  .textarea {\n    min-height: 100px;\n    resize: vertical;\n  }\n  \n  .input:focus, .select:focus, .textarea:focus {\n    border-color: #ff3333;\n    outline: none;\n  }\n  \n  .checkboxLabel {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n  }\n  \n  .checkbox {\n    width: 18px;\n    height: 18px;\n    accent-color: #ff3333;\n  }\n  \n  .fileInput {\n    padding: 0.75rem;\n    border-radius: 4px;\n    border: 1px solid #333;\n    background-color: #111;\n    color: #fff;\n    width: 100%;\n    cursor: pointer;\n  }\n  \n  .fileInput::-webkit-file-upload-button {\n    background-color: #ff3333;\n    color: white;\n    border: none;\n    padding: 0.5rem 1rem;\n    margin-right: 1rem;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  \n  .imageUploadContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  @media (min-width: 768px) {\n    .imageUploadContainer {\n      flex-direction: row;\n      gap: 2rem;\n    }\n  }\n  \n  .imageUpload {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  \n  .imagePreview, .filesPreview {\n    margin-top: 0.5rem;\n    padding: 0.5rem;\n    background-color: #222;\n    border-radius: 4px;\n    font-size: 0.9rem;\n  }\n  \n  .metadataSection {\n    margin-top: 1rem;\n    border-top: 1px solid #333;\n    padding-top: 1.5rem;\n  }\n  \n  .metadataSection h3 {\n    font-size: 1.5rem;\n    color: #ff3333;\n    margin-bottom: 1rem;\n  }\n  \n  .metadataItem {\n    background-color: #111;\n    padding: 1.5rem;\n    border-radius: 8px;\n    margin-bottom: 1.5rem;\n    border-left: 4px solid #ff3333;\n  }\n  \n  .metadataItem h4 {\n    margin-top: 0;\n    margin-bottom: 1rem;\n    font-size: 1.2rem;\n    color: #ddd;\n  }\n  \n  .formAction {\n    margin-top: 2rem;\n    display: flex;\n    justify-content: center;\n  }\n  \n  .submitButton {\n    background-color: #ff3333;\n    color: white;\n    border: none;\n    padding: 0.75rem 2rem;\n    font-size: 1.1rem;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    min-width: 200px;\n  }\n  \n  .submitButton:hover {\n    background-color: #cc0000;\n  }\n  \n  .submitButton:disabled {\n    background-color: #777;\n    cursor: not-allowed;\n  }\n  \n  .message {\n    padding: 1rem;\n    border-radius: 4px;\n    margin-bottom: 2rem;\n    font-weight: 500;\n  }\n  \n  .success {\n    background-color: rgba(0, 128, 0, 0.2);\n    color: #4caf50;\n    border: 1px solid #4caf50;\n  }\n  \n  .error {\n    background-color: rgba(255, 0, 0, 0.2);\n    color: #ff3333;\n    border: 1px solid #ff3333;\n  }\n  .imagePreview {\n    position: relative;\n    display: inline-block;\n    margin-top: 10px;\n  }\n  \n  .previewImg {\n    max-width: 100px;\n    max-height: 100px;\n    border-radius: 6px;\n    object-fit: cover;\n  }\n  \n  .removeBtn {\n    position: absolute;\n    top: -8px;\n    right: -8px;\n    background: red;\n    color: white;\n    border: none;\n    border-radius: 50%;\n    font-size: 16px;\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .removeAudioBtn {\n    background: transparent;\n    border: none;\n    color: #ff4d4f;\n    font-size: 30px;\n    font-weight: bold;\n    cursor: pointer;\n    margin-left: auto;\n  }\n  \n  .metadataHeader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  \n  /* Responsive adjustments */\n  @media (max-width: 768px) {\n    .container {\n      padding: 1rem;\n    }\n    \n    .title {\n      font-size: 1.5rem;\n    }\n    \n    .metadataItem {\n      padding: 1rem;\n    }\n    \n    .submitButton {\n      width: 100%;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AddMultipleAudios_container__QQcUG`,
	"title": `AddMultipleAudios_title__v14rz`,
	"form": `AddMultipleAudios_form__9rC0N`,
	"formGroup": `AddMultipleAudios_formGroup__NP1d3`,
	"input": `AddMultipleAudios_input__lt78c`,
	"select": `AddMultipleAudios_select__+c2Mi`,
	"textarea": `AddMultipleAudios_textarea__zzCwU`,
	"checkboxLabel": `AddMultipleAudios_checkboxLabel__2AQuy`,
	"checkbox": `AddMultipleAudios_checkbox__RTH++`,
	"fileInput": `AddMultipleAudios_fileInput__SamwF`,
	"imageUploadContainer": `AddMultipleAudios_imageUploadContainer__QP3hJ`,
	"imageUpload": `AddMultipleAudios_imageUpload__uOusD`,
	"imagePreview": `AddMultipleAudios_imagePreview__PzzOM`,
	"filesPreview": `AddMultipleAudios_filesPreview__qvsX3`,
	"metadataSection": `AddMultipleAudios_metadataSection__0CaHQ`,
	"metadataItem": `AddMultipleAudios_metadataItem__u3DvI`,
	"formAction": `AddMultipleAudios_formAction__Uo2bx`,
	"submitButton": `AddMultipleAudios_submitButton__Smhxb`,
	"message": `AddMultipleAudios_message__2DHj2`,
	"success": `AddMultipleAudios_success__p7reB`,
	"error": `AddMultipleAudios_error__HIZvf`,
	"previewImg": `AddMultipleAudios_previewImg__Bu4-V`,
	"removeBtn": `AddMultipleAudios_removeBtn__DLz2e`,
	"removeAudioBtn": `AddMultipleAudios_removeAudioBtn__M-ZCW`,
	"metadataHeader": `AddMultipleAudios_metadataHeader__XTXqC`
};
export default ___CSS_LOADER_EXPORT___;
